
export default {
  computed: {
    alertObj() {
      return this.$store.state.alertObj
    },
    show() {
      return !!this.alertObj
    }
  },
  methods: {
    alertClass() {
      if (this.alertObj) {
        switch(this.alertObj.type) {
          case 'success':
            return 'show alert-success'
          case 'error':
            return 'show alert-success'
          case 'info':
            return 'show alert-info'
        }
      }
      return ''
    },
  }
}
